import { getRegionConfigByCountry } from 'custom-config/region.configs';
import React, { useEffect, useState } from 'react';
import { GetDomainName } from '~/helpers/UrlHelper';
import { ListingEnquiryFormUrl } from '~/lib/helpers/regionPardotFormHelper';

interface EnquireNowFormProps {
    region?: string;
    path?: string;
    canonicalCountry: string;
    favouriteSFIDs?: string[];
    ssid?: string;
    className?: string;
    lockViewportScale?: boolean;
}

const EnquireNowForm: React.FC<EnquireNowFormProps> = (props) => {
    const currentDomain = GetDomainName();
    // const { favorites } = useFavorite();
    const { region } = getRegionConfigByCountry(props.canonicalCountry);
    const iFrameUrl = `${ListingEnquiryFormUrl(
        region
    )}?${currentDomain}${props.path}`;

    const [isIframeLoaded, setIsIframeLoaded] = useState(false);

    useEffect(() => {
        if (!props.lockViewportScale) return;
        if (typeof document === "undefined" || typeof navigator === "undefined") return;

        const isIOS =
            /iP(ad|hone|od)/.test(navigator.userAgent) ||
            (navigator.userAgent.includes("Mac") && "ontouchend" in document);
        if (!isIOS) return;

        const meta = document.querySelector<HTMLMetaElement>('meta[name="viewport"]');
        if (!meta) return;

        const originalContent = meta.getAttribute("content") ?? "";
        const parts = originalContent
            .split(",")
            .map((part) => part.trim())
            .filter(Boolean)
            .filter((part) => !/^maximum-scale/i.test(part) && !/^user-scalable/i.test(part));
        parts.push("maximum-scale=1", "user-scalable=no");
        const nextContent = parts.join(", ");

        meta.setAttribute("content", nextContent);

        return () => {
            meta.setAttribute("content", originalContent);
        };
    }, [props.lockViewportScale]);

    return (
        <>

            <div className="relative container-none sm:container overflow-x-hidden pb-0">
                <div className="flex justify-center w-full">
                    <div className="w-full pt-1 h-[30rem] flex justify-center items-start overflow-hidden min-w-0">
                        {!isIframeLoaded && (
                            <div className="absolute inset-0 flex flex-col items-center justify-center bg-oh-black/1 z-10">
                                <div className="animate-spin rounded-full h-12 w-12 border-4 border-primary border-t-transparent"></div>
                                <span className="mt-4 text-gray-600">Loading...</span>
                            </div>
                        )}
                        <iframe
                            src={iFrameUrl}
                            title="embedded enquiry webpage"
                            className={`h-[30rem] w-full max-w-full min-w-0 text-center ${props.className || ''}`}
                            onLoad={() => setIsIframeLoaded(true)}
                            style={!isIframeLoaded ? { visibility: 'hidden' } : {}}
                            sandbox="allow-same-origin allow-forms allow-scripts allow-popups"
                        ></iframe>
                    </div>
                </div>
            </div>
        </>
    );
};

export default EnquireNowForm;
